export enum EShiftSession {
  DayOff,
  MorningShift,
  AfternoonShift,
  AllDay
}
